/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoSlotsAvailable/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Button from 'DesignSystem/Button/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoSlotsAvailable({
  children,
  viewPath = "/App/Form/Data/ProvideData/AppointmentSlot/Notifications/NoSlotsAvailable",
  onClick
  
}) {
  return (<React.Fragment
>
<div
  data-testid="NoSlotsAvailable.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="NoSlotsAvailable.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Apologies. There are no appointments available this month.
</span>
<Button
  viewPath={`${viewPath}/Button`}
 alignSelf="center"
 onClick={onClick}
 text="Check next month"
/>
</div>
{children}
</React.Fragment>)
}